import React from 'react';
// Zustand
import { useStore } from '../../zustand';
// Icons
// import { ReactComponent as Checkmark } from "../../assets/icons/checkmark.svg"
// import { ReactComponent as IconStar } from "../../assets/icons/star.svg";
// Components
import ReviewItem from '../BillboardUI/ReviewItem';
// import BillboardsMobileDropdown from './BillboardsMobileDropdown';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { billboardStyles } from "../../assets/jss/billboardStyles";
const useStyles = makeStyles(billboardStyles);

export default function BillboardTabs(props) {
    const { tab, device, description } = props;
    const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { active_tab } = useStore(state => state.scene_controls);
    const reviews = useStore.getState().reviews;
    const classes = useStyles(dynamic_text_settings);
    // const { vList } = useStore.getState().variants_payload;
    // const variant_id = useStore.getState().variant_id;
    // const { origin, variant_type } = useStore.getState().settings;

    const _handleTabSelect = (targetTab) => {
      //setState({ tab: targetTab }) // Update tab state
      useStore.setState(state => ({ 
          scene_controls: { 
              ...state.scene_controls,
              active_tab: targetTab
          }
      }));
      return false;
    }

    const _displayReviews = (reviews) => {
        let content = [],
            review;
        var maxCount = reviews.length;
        if (reviews.length > 3) maxCount = 3;
        for (let i = 0; i < maxCount; i++) {
          review = reviews[i];
          content.push(<ReviewItem author={review.user.display_name} date={review.created_at} score={review.score} title={review.title} content={review.content} verified={review.verified_buyer} key={i} index={i} device={device} />);
        }
        return content;
    }

    const _displayTabBody = (tab) => {
      switch(tab) {
        case 0:
          return (
            <div className={classes.product_description}><p>{description ? description : 'This waterproof hiking boot keeps your feet dry and lets them breathe, and the aggressive outsole bites into the terrain. It\'s built for all-day comfort, and the mid-cut height adds ankle support.'}</p></div>
          )
        case 1:
          return (
            <div className={classes.reviews_full}>
                { _displayReviews(reviews.response.reviews)}
            </div>
          )
        case 2:
          return;
          // return (
          //   <BillboardsMobileDropdown spec={spec} />
          // )
        default:
          return (
            <div className={classes.product_description}><p>{description ? description : 'This waterproof hiking boot keeps your feet dry and lets them breathe, and the aggressive outsole bites into the terrain. It\'s built for all-day comfort, and the mid-cut height adds ankle support.'}</p></div>
          )
      }
    }

    if(origin === 'static') return null;

    return(
      <div className={classes.billboard_tabs_container}>
        <div className={`${classes.billboard_tabs} ${device === 'mobile' ? 'billboard_info_tabs_mobile' : 'billboard_info_tabs_desktop'}`}>
            <span className={`${active_tab === 0 ? 'active' : ''}`} onClick={() => _handleTabSelect(0)}>Video</span>
            <span className={`${active_tab === 1 ? 'active' : ''}`} onClick={() => _handleTabSelect(1)}>Reviews</span>
            <span className={`${active_tab === 2 ? 'active' : ''}`} onClick={() => _handleTabSelect(2)}>Features</span>            
        </div>
        <div className={`${classes.billboard_tabs_body} ${device === 'mobile' ? 'billboard_tabs_body_mobile' : 'billboard_tabs_body_desktop'}`}>
          {_displayTabBody(tab)}
        </div>
      </div>
    )
}